import React,{useState,useEffect} from 'react'

function ProductivityUIGrid(props) {
    const formatDateString = (dateparam) => {
        return dateparam.toLocaleDateString("en-CA", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        });
    }


    return (
        <div>
            <table className="table table-bordered">
                <thead>
                    <tr>
                        <th className="qcHeaderbg sl_no">
                            <label>Sl. No</label>
                        </th>
                        <th className="qcHeaderbg message_block">
                            <label>Validation</label>
                        </th>
                        <th className="qcHeaderbg">
                            <label>Release Category</label>
                        </th>
                        <th className="qcHeaderbg message_block" >
                            <label>Release Description</label>
                        </th>
                        <th className="qcHeaderbg">
                            <label>OHR</label>
                        </th>
                        <th className="qcHeaderbg">
                            <label>Release Date</label>
                        </th>
                        <th className="qcHeaderbg">
                            <label>Released From PID</label>
                        </th>
                        <th className="qcHeaderbg">
                            <label>Name</label>
                        </th>
                        <th className="qcHeaderbg">
                            <label>Account</label>
                        </th>
                        <th className="qcHeaderbg">
                            <label>Region</label>
                        </th>
                        <th className="qcHeaderbg">
                            <label>Release Type</label>
                        </th>
                        <th className="qcHeaderbg">
                            <label>Cost Code</label>
                        </th>
                        <th className="qcHeaderbg">
                            <label>Billability</label>
                        </th>
                        
                        <th className="qcHeaderbg message_block">
                            <label>Headcount Release Levers</label>
                        </th>
                        <th className="qcHeaderbg" style={{ display: 'none' }}>
                            <label>Comment</label>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {
                        props.data && props.data.map((item, index) => {
                            return (
                                <tr key={index}>
                                    <td>
                                        <label>{index + 1}</label>
                                    </td>
                                    <td style={{ textAlign: "left" }}>
                                        <label>{item.Msg ? item.Msg : (item.Msg === null || item.Msg === undefined || !item.Msg ? "Successful" : "")}</label>
                                    </td>
                                    <td>
                                        <label>{item.Catg ? item.Catg : "-"}</label>
                                    </td>
                                    <td className='release_description'>
                                        <label>{item.Descr ? item.Descr : "-"}</label>
                                    </td>
                                    <td>
                                        <label>{item.OHR ? item.OHR : "-"}</label>
                                    </td>
                                    <td>
                                        <label>{item.ReleaseDate ? formatDateString(new Date(item.ReleaseDate)) : "-"}</label>
                                    </td>
                                    <td>
                                        <label>{item.PID ? item.PID : "-"}</label>
                                    </td>
                                    <td>
                                        <label>{item.OHRName ? item.OHRName : "-"}</label>
                                    </td>
                                    <td>
                                        <label>{item.Account ? item.Account : "-"}</label>
                                    </td>
                                    <td>
                                        <label>{item.Region ? item.Region : "-"}</label>
                                    </td>
                                    <td>
                                        <label>{item.ReleaseType ? item.ReleaseType : "-"}</label>
                                    </td>
                                    <td>
                                        <label>{item.ReleaseCode ? item.ReleaseCode : "-"}</label>
                                    </td>
                                    <td>
                                        <label>{item.Billability ? item.Billability : "-"}</label>
                                    </td >
                                    
                                    <td>
                                        <label>{item.HCLever ? item.HCLever : "-"}</label>
                                    </td>
                                    <td style={{ display: "none" }}>
                                        <label>{item.Comment ? item.Comment : "-"}</label>
                                    </td>
                                </tr>
                            )
                        })
                    }


                </tbody>

            </table>
        </div>
    )
}

export default ProductivityUIGrid